import { useEffect, useState } from 'react';
import useInterval from 'hooks/useInterval';
import { isMetaVersionGreaterThanPackageVersion } from 'utils/CacheBustingUtils';
import { isAcceptance, isLocal } from 'helpers/helper_functions';

const POLLING_FREQUENCY = 60000;

export function useCacheBusting(pollingFrequency = POLLING_FREQUENCY) {
  const [isAppOutdated, setIsAppOutdated] = useState(false);
  const shouldCheckCache = !(isLocal() || isAcceptance());

  async function checkCache() {
    const isPackageVersionOutdated =
      await isMetaVersionGreaterThanPackageVersion();
    if (isPackageVersionOutdated) {
      setIsAppOutdated(true);
    } else {
      setIsAppOutdated(false);
    }
  }

  useInterval(checkCache, shouldCheckCache ? pollingFrequency : undefined);

  useEffect(() => {
    if (shouldCheckCache) {
      checkCache();
    }
  }, []);

  return {
    isAppOutdated,
  };
}
